import { render, staticRenderFns } from "./orderreturn-list.vue?vue&type=template&id=aa6fcf6c&"
import script from "./orderreturn-list.vue?vue&type=script&lang=ts&"
export * from "./orderreturn-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports